<div class="appointments-dashboard" data-ktportlet="true" id="kt_portlet_tools_1">
  <header class="dashboard-header">
    <div class="header-content">
      <div class="dashboard-title-row">
        <i class="fas fa-calendar-check dashboard-icon"></i>
        <h2 class="title">
          {{ "connect.calendar.appointment_confirm" | translate }}
        </h2>
      </div>
      <div class="appointment-counter">
        <span class="counter" [class.shine-animation]="toConfirmBookingSlots.length > 0">{{ this.totalCount}}</span>
        @if (toConfirmBookingSlots.length > 0) {
          <i class="fas fa-bell counter-bell" [class.bell-animate]="toConfirmBookingSlots.length > 0"></i>
        }
      </div>
    </div>
  </header>

  <div class="appointments-container" kt-hidden-height="259">
    @if (toConfirmBookingSlots.length !== 0) {
      <div class="appointments-list kt-notification-v2">
        @for (bookingSlot of toConfirmBookingSlots; track bookingSlot) {
          <div class="appointment-card">
            <div class="card-content">
              <div class="card-header">
                <div class="avatar large">
                  <span>{{ getPatientInitials(bookingSlot) }}</span>
                </div>
                <div class="patient-main-info">
                  <h3 class="patient-name">
                    {{ bookingSlot.title }}
                  </h3>
                  <div class="patient-subtitle">
                    <i class="far fa-envelope"></i> {{ bookingSlot.user_email || bookingSlot.user_phone_number }}
                  </div>
                  <div class="appointment-time">
                    <i class="far fa-clock"></i>
                    {{ bookingSlot.starts_at | customDate }}, {{ bookingSlot.starts_at | customTime }} - {{ bookingSlot.ends_at | customTime }}
                  </div>
                </div>
              </div>
              <div class="patient-details">
                <div class="contact-info">
                  <a class="contact-link email" href="mailto:{{ bookingSlot.user_email }}" title="{{ bookingSlot.user_email }}">
                    <i class="far fa-envelope"></i>
                  </a>
                  <a class="contact-link phone" href="tel:{{ bookingSlot.user_phone_number }}" title="{{ bookingSlot.user_phone_number }}">
                    <i class="fas fa-phone"></i> {{ bookingSlot.user_phone_number }}
                  </a>
                </div>
                <span class="request-age">
                  {{ "connect.online-booking.age" | translate }} :
                  {{ bookingSlot?.user_age ?? '00' }}
                </span>
              </div>
              <div class="request-info">
                <span class="request-time">
                  {{ "connect.calendar.requested" | translate }}
                  {{ bookingSlot.created_at | timeAgo : currentDoctor.locale }}
                </span>
              </div>
              <!-- Missed Appointments Count -->
              @if (bookingSlot.missed_appointments_count && bookingSlot.missed_appointments_count > 2) {
                <div class="missed-appointments-alert"
               [ngClass]="{
                 'alert-low': bookingSlot.missed_appointments_count <= 3,
                 'alert-medium': bookingSlot.missed_appointments_count > 3 && bookingSlot.missed_appointments_count <= 5,
                 'alert-high': bookingSlot.missed_appointments_count > 5
               }">
                  <div class="alert-icon">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                  </div>
                  <div class="alert-content">
                    <div class="alert-title">{{ "connect.globals.missed_appointments" | translate }}</div>
                    <div class="alert-count">{{ bookingSlot.missed_appointments_count }} {{ "connect.globals.missed_appointments_count" | translate }}</div>
                  </div>
                  @if (bookingSlot.missed_appointments_count >= 3) {
                    <div class="alert-badge">
                      <span class="badge-number">{{ bookingSlot.missed_appointments_count }}</span>
                    </div>
                  }
                </div>
              }
              <div class="tags-container">
                <div class="primary-tags">
                  @if (bookingSlot.type === bookingTypes.OFFICE) {
                    <span class="tag type">
                      {{ "connect.appointment_table." + bookingTypes.OFFICE | translate }}
                    </span>
                  }
                  @if (bookingSlot.type === bookingTypes.HOME) {
                    <span class="tag type">
                      {{ "connect.appointment_table." + bookingTypes.HOME | translate }}
                    </span>
                  }
                  @if (bookingSlot.department) {
                    <span class="tag department">
                      {{bookingSlot.department?.name}}
                    </span>
                  }
                  @for (type of doctorBookingTypes; track type) {
                    @if (type.id === bookingSlot.booking_slot_type_id) {
                      <span class="tag booking-type"
                        [style.background-color]="type.color">
                        {{ type.name | titlecase }}
                      </span>
                    }
                  }
                  @if (bookingSlot.resourceId && bookingSlot.resource) {
                    <hr class="visits-divider">
                    <span class="tag resource">
                      {{ bookingSlot.resource }}
                    </span>
                  }
                </div>
                @if (bookingSlot.metadata?.confirmed_bookings_count >= 0) {
                  <hr class="visits-divider">
                  <span class="tag visits" [class.first-visit]="bookingSlot.metadata?.confirmed_bookings_count == 0">
                    @if (bookingSlot.metadata?.confirmed_bookings_count == 0) {
                      {{ "connect.calendar.first_time_appointment" | translate }}
                    }
                    @if (bookingSlot.metadata?.confirmed_bookings_count > 0) {
                      {{ "connect.calendar.total_number_of_appointments" | translate }}:
                      {{ bookingSlot.metadata.confirmed_bookings_count }}
                    }
                  </span>
                }
              </div>
            </div>
            <div class="card-actions" role="group" [attr.aria-label]="'connect.calendar.appointment_actions' | translate">
              <p-button
                type="button"
                icon="pi pi-check"
                severity="success"
                [text]="true"
                styleClass="action-bar-btn confirm"
                (onClick)="confirmBookingSlot(bookingSlot)"
                [pTooltip]="'connect.globals.booking_confirm' | translate"
                tooltipPosition="top"
                [ariaLabel]="'connect.globals.booking_confirm' | translate">
              </p-button>
              <p-button
                type="button"
                icon="pi pi-times"
                severity="danger"
                [text]="true"
                styleClass="action-bar-btn decline"
                (onClick)="cancelBookingSlot(bookingSlot)"
                [pTooltip]="'connect.globals.cancel_booking' | translate"
                tooltipPosition="top"
                [ariaLabel]="'connect.globals.cancel_booking' | translate">
              </p-button>
              <p-button
                type="button"
                icon="pi pi-pencil"
                severity="info"
                [text]="true"
                styleClass="action-bar-btn edit"
                (onClick)="editBookingSlot(bookingSlot)"
                [pTooltip]="'connect.online-booking.modify' | translate"
                tooltipPosition="top"
                [ariaLabel]="'connect.online-booking.modify' | translate">
              </p-button>
              <p-button
                type="button"
                icon="pi pi-phone"
                severity="help"
                [text]="true"
                styleClass="action-bar-btn call"
                (onClick)="callPatient(bookingSlot)"
                [pTooltip]="bookingSlot.user_phone_number || ('connect.online-booking.phone' | translate)"
                tooltipPosition="top"
                [ariaLabel]="('connect.online-booking.phone' | translate) + ' ' + (bookingSlot.user_phone_number || '')">
              </p-button>
            </div>
          </div>
        }
      </div>
    }

    @if (toConfirmBookingSlots.length === 0) {
      <div class="empty-state kt-notification-v2">
        <i class="far fa-calendar-check empty-icon"></i>
        <p>{{ "connect.calendar.appointment_request" | translate }}</p>
      </div>
    }
  </div>
  @if (totalPages > 1) {
    <nav class="appointments-pagination" [attr.aria-label]="'connect.calendar.appointment_confirm' | translate">
      <p-button
        type="button"
        icon="pi pi-chevron-left"
        severity="secondary"
        [text]="true"
        styleClass="pagination-bar-btn previous"
        [label]="'connect.calendar.previous' | translate"
        [disabled]="currentPage === 1 || loading"
        (onClick)="previousPage()">
      </p-button>
      <span class="pagination-info" aria-live="polite">
        {{ "connect.calendar.page_info" | translate:{ current: currentPage, total: totalPages } }}
      </span>
      <p-button
        type="button"
        icon="pi pi-chevron-right"
        iconPos="right"
        severity="secondary"
        [text]="true"
        styleClass="pagination-bar-btn next"
        [label]="'connect.calendar.next' | translate"
        [disabled]="currentPage === totalPages || loading"
        (onClick)="nextPage()">
      </p-button>
    </nav>
  }
</div>